import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Farmer from '@/views/Farmer.vue';
import Manager from '@/views/Manager.vue';
import Home from '@/views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Farmer,
  },
  // {
  //   path: '/manager',
  //   name: 'Farm Manager',
  //   component: Manager,
  // },
  // {
  //   path: '/farmer',
  //   name: 'Farmer',
  //   component: Farmer,
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
